import React, { useContext } from 'react';
import { ITypeVignettesOrderManagementFields, VignetteContext } from '@adac-mp/shared';
import { Button } from '../../index';

interface ICancelOrderButtonProps {
	onClick: () => void;
}

export const CancelOrderButton = ({ onClick }: ICancelOrderButtonProps) => {
	const { contentfulLabels } = useContext(VignetteContext);
	const currentLabels = contentfulLabels as ITypeVignettesOrderManagementFields;

	return (
		<div className="sticky w-full bottom-0 right-0 bg-white p-1.5 flex flex-col gap-1.5 md:p-0 md:static md:mt-6 md:bg-transparent md:w-4/12 md:mx-auto">
			<Button
				className="w-full mb-0"
				tracking={{
					button_click: {
						label: currentLabels?.headlineIntro || 'Bestellung verwalten',
						element: currentLabels?.headlineIntro || 'Bestellung verwalten',
					},
				}}
				onClick={onClick}>
				{currentLabels?.headlineIntro || 'Bestellung verwalten'}
			</Button>
		</div>
	);
};
